import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Row } from "react-bootstrap";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useNavigate, useParams } from "react-router-dom";

export default () => {

  const moduleName = `delivery_days`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const [id, setId] = useState();

  const params = useParams()
  
  const navigate = useNavigate()

  const [submitted, setSubmitted] = useState(false);

  const [cartTimeDuration, setCartTimeDuration] = useState(``);
  const [maxDays, setMaxDays] = useState(``);

  const fixDayItem = {
    id: 0,
    started_at: "",
    finished_at: "",
    price: 0,
  }

  const locale = {
    started_at: "از ساعت",
    finished_at: "تا ساعت",
    price: "قیمت",
  }

  const [dayItems, setDayItems] = useState([fixDayItem])

  const handleDelete = (index) => {
    setDayItems([
      ...dayItems.slice(0, index),
      ...dayItems.slice(index + 1, dayItems.length)
    ]);
  }

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.delivery_days_store != undefined && appReducer.delivery_days_store.error == false) ||
        (appReducer.delivery_days_update != undefined && appReducer.delivery_days_update.error == false)
      ) {
        
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.delivery_days_store,
    appReducer.delivery_days_update
  ])

  const appendNewItem = () => setDayItems([...dayItems, fixDayItem]);

  useEffect(() => {
    if (appReducer.delivery_days_list != undefined) {
      let row = appReducer.delivery_days_list.data;
      setCartTimeDuration(row.cart_time_duration);
      setMaxDays(row.max_days);
      setDayItems(row.items)
    }
  }, [appReducer.delivery_days_list]);

  useEffect(() => {
    dispatch(actions.list(moduleName));
  }, []);

  return <Template.Form>
    <Template.Input
      required
      value={cartTimeDuration}
      label="شروع محاسبه تعداد روز بعد از خرید"
      name="cart_time_duration"
      type="text"
    />
    <Template.Input
      required
      value={maxDays}
      label="تعداد کل روزهای تحویل"
      name="max_days"
      type="text"
    />

    

    <div className=" flex justify-between items-center">
    <h3 className=" font-bold text-lg">زمان‌های تحویل</h3>
    <Template.Button label="افزودن مورد جدید" onClick={() => appendNewItem()} background="bg-gradient-to-tr from-blue-300 to-blue-400" />
  </div>

    {dayItems.map(function (days, key) {

      return <div key={key} className="  grid grid-cols-4 gap-5 ">
        {
          Object.entries(days).map((item) => {

            if (locale[item[0]] != undefined) {
              return <div className="col-md-3">
                <Template.Input
                  required
                  value={item[1]}
                  label={locale[item[0]]}
                  name={`days[${key}][${item[0]}]`}
                  type="text"
                />
              </div>
            }

            if (item[0] == "id") {

              return <button className=" bg-rose-100 text-rose-500 rounded-md" onClick={() => handleDelete(key)}>حذف</button>
           
            }

          })
        }
      </div>
    })}

    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};